import Splide from '@splidejs/splide';

class Slide {
    constructor() {
        this.sliders = document.querySelectorAll('.splide');

        this.init();
    }

    init() {
        Array.from(this.sliders).forEach((item) => {
            const sp = new Splide(item, {
                perPage: 1,
                perMove: 1,
                pagination: false,
                padding: { right: '20%' },
                gap: '102px',
                arrows: true,
                breakpoints: {
                    768: {
                        padding: { right: 0 },
                    },
                },
            });

            sp.mount();
        });
    }
}

export default Slide;
